import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { LoadingScreen } from "@/components/shared/LoadingScreen";

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // 2FA enforcement: if the org policy requires it for this user but
  // they haven't set it up yet, force-route them to the setup page.
  // The setup page itself is whitelisted so they can complete the
  // flow; everything else under the protected tree is locked.
  const setupPath = "/account/security/setup-2fa";
  if (
    user?.must_setup_2fa &&
    location.pathname !== setupPath &&
    !location.pathname.startsWith("/logout")
  ) {
    return <Navigate to={setupPath} replace />;
  }

  return <Outlet />;
}
